import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { useEffect } from 'react';

export const EmailVerified = () => {
  useEffect(() => {
    // Auto-refresh after 3 seconds
    const timer = setTimeout(() => {
      window.close() || (window.location.href = '/');
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center p-4">
      <div className="bg-[#4A4A4A]/20 backdrop-blur-md border border-white/20 rounded-[50px] p-12 max-w-md w-full text-center text-white">
        <div className="flex justify-center mb-6">
          <div className="bg-green-500/20 rounded-full p-4">
            <CheckCircleIcon className="w-20 h-20 text-green-400" />
          </div>
        </div>

        <h1 className="text-3xl font-bold mb-4">Email Verified!</h1>

        <p className="text-white/80 text-lg mb-2">
          Your email has been successfully verified.
        </p>

        <p className="text-white/60 text-sm mb-8">
          You can now close this tab and refresh the app to continue.
        </p>

        <div className="text-white/40 text-xs">
          This page will close automatically in a few seconds...
        </div>
      </div>
    </div>
  );
};
